import { Recomendation } from "../interfaces/interfaces";

export const getValidOptimalPrice = (
  recomendacion?: Recomendation,
): number | null => {
  if (!recomendacion || recomendacion.mensaje) return null;
  return recomendacion.precio_recomendado ?? null;
};
